import Box from '@/common/components/Box'
import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { UserRoundIcon } from 'lucide-react'
import TextField from '@/common/components/TextField'
import { formatDateTime } from '@/common/utils/formatters'
import { TmaisUserData } from '@/features/tmaisUsers/types/tmaisUsers.type'

interface TmaisUserGeneralData {
  tmaisUser: TmaisUserData
}

export default function TmaisUserGeneralData({tmaisUser}: TmaisUserGeneralData) {
  return (
    <Box className='flex flex-col gap-2'>
      <h2 className='text-lg font-bold'>Detalhes do cliente</h2>

      <div className="flex flex-col gap-1">
        <p className="text-xs">Foto</p>
        <ImageWithPlaceholder
          url={tmaisUser?.profile_picture?.url}
          alt={tmaisUser?.full_name}
          className="size-20"
          iconClassName="size-20"
          placeholderIcon={UserRoundIcon}
        />
      </div>

      <div className='flex items-center gap-2'>
        <TextField
          label="Nome"
          value={tmaisUser?.full_name}
          data-testid="full_name_input"
          className='w-1/2'
          disabled
          />
        <TextField
          label="Data e hora de cadastro"
          value={tmaisUser?.created_at ? formatDateTime(new Date(tmaisUser.created_at)) : ''}
          data-testid="created_at_input"
          className='w-1/2'
          disabled
        />
      </div>
    </Box>
  )
}
